import { render, staticRenderFns } from "./ProductResourcesModal.vue?vue&type=template&id=a74534ae"
import script from "./ProductResourcesModal.vue?vue&type=script&lang=js"
export * from "./ProductResourcesModal.vue?vue&type=script&lang=js"
import style0 from "./ProductResourcesModal.vue?vue&type=style&index=0&id=a74534ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports